export default function Django_Comment() {
  return <div>Django_Comment Component</div>;
}
